import * as React from 'react';
import { Tile } from '../../../models/Mahjong';
import { TileImage } from 'src/sections/mahjong/components/TileImage';
import { AnimatedTileImage } from './AnimatedTileImage';

interface HandProps {
    tiles: Tile[];
    tileHeight?: number;
    isInteractive?: boolean;
    onTileClick?: (tile: Tile, index: number) => void;
    faceDown?: boolean | ((tile: Tile, index: number) => boolean);
}

export function Hand({ tiles, tileHeight, isInteractive, onTileClick, faceDown }: HandProps): JSX.Element {
    const h = tileHeight ?? 60;
    const w = h * (44 / 60);

    return (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(${w}px, 1fr))`, gap: '4px', justifyItems: 'center' }}>
            {tiles.map((tile, index) => {
                const isFaceDown = typeof faceDown === 'function' ? faceDown(tile, index) : faceDown;
                return isInteractive ? (
                    <AnimatedTileImage
                        key={tile.id}
                        tile={tile}
                        height={tileHeight}
                        onClick={() => onTileClick && onTileClick(tile, index)}
                        faceDown={isFaceDown}
                    />
                ) : (
                    <TileImage key={tile.id} tile={tile} height={tileHeight} faceDown={isFaceDown} />
                );
            })}
        </div>
    );
}
